import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Paciente } from '../../paciente';
import { DependenteService } from '../dependente.service';

@Component({
  selector: 'app-dependente-maintenance',
  templateUrl: './dependente-maintenance.component.html',
  styleUrls: ['./dependente-maintenance.component.css']
})
export class DependenteMaintenanceComponent implements OnInit {

  id: number;

  isUpdate: string;

  isInfo: boolean = false;

  dependente: Paciente;

  formularioDependente: FormGroup;

  tituloCrud: string = '';

  constructor(private dependenteService: DependenteService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.dependente = new Paciente();

    this.formularioDependente = this.formBuilder.group({
      id: 0,
      nome: ['', [Validators.required, Validators.minLength(6)]],
      cpf: [''],
      dataNascimento: ['', [Validators.required]],
      foneResidencial: [''],
      foneCelular: [''],
      dependentes: [[]],
      dependenteAtivo: [false],
      dependentesExcluidos: [[]],
    });
  }

  ngOnInit() {

    if (this.isUpdate == 'S') {
      this.tituloCrud = 'Alterar Dependente';
    } else {
      this.isInfo = true;
      this.tituloCrud = 'Detalhe Dependente';
    }

    this.configurarForm();
  }

  save() {

    this.dependente = this.formularioDependente.value;

    this.dependenteService.atualizar(this.dependente)
      .subscribe(data => {
        // console.log(data); 

        this.gotoList();
      }, error => {
        console.log(error);
      });
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/dependentes'], {
      state: {
        filtroDependente: history.state.filtroDependente,
      }
    });
  }

  isNew(): boolean {
    return this.id == null || this.id == 0;
  }

  get formControl() {
    return this.formularioDependente.controls;
  }

  configurarForm(): void {
    this.dependenteService.procurarDependentesPorIdIncluindoInativos(this.id)
      .subscribe(data => {
        // console.log(data)

        this.dependente = data;

        this.formularioDependente.setValue(this.dependente);

        this.cd.detectChanges();

        if (this.isUpdate == 'N') {
          this.formularioDependente.disable();
        }
      }, error => {
        console.log(error);
      });
  }

}
